export default __webpack_public_path__ + "static/media/resources.655cacf2.png";